export default "__VITE_ASSET__DB4Kp2ai__"